// external imports
import ReactDOM from 'react-dom'
import React from 'react'
import { AppContainer } from 'react-hot-loader'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { Theme } from 'quark-web'
// local imports
import { primaryColor, primaryColorDark } from '~/colors'
import { Root, PrintProduct } from './views'

const render = Component => {
    ReactDOM.render(
        <AppContainer>
            <Theme colors={{ primaryColor, primaryColorDark }}>
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/print/:id" render={({ match }) => <PrintProduct id={match.params.id} />} />
                        <Route component={Component} />
                    </Switch>
                </BrowserRouter>
            </Theme>
        </AppContainer>,
        document.getElementById('root')
    )
}

render(Root)

// Webpack Hot Module Replacement API
module.hot &&
    module.hot.accept('./views', () => {
        render(Root)
    })



// WEBPACK FOOTER //
// ./src/index.js